'use strict';

(function () {
  var afterGetSettings = null;

  var localstorageName;
  var token;
  socket.emit('plugins.screeps.getSettings', {}, function(err, result) {
    if (err) {
      console.error('Cannot fetch plugin settings', err);
      return;
    }
    if (!result) {
      console.error('Something wrong with plugin setting');
      return;
    }
    localstorageName = result.localstorageName;
    console.log('loaded localstorageName', localstorageName);
    if (afterGetSettings) {
      afterGetSettings();
      afterGetSettings = null;
    }
  });

  $(window).on('action:app.load', function () {
    console.log('action:app.load');
    function tryToAuth() {
      console.log('getting value of ', localstorageName);
      token = localStorage.getItem(localstorageName);
      console.log('got token ', token);
      if (token) {
        // Unwrapping if it's in quotes
        token = (token[0]==='"' && token[token.length - 1]==='"') ?
          token.substr(1, token.length - 2) : token;
        console.log('unwrapped token ', token);
        var baseUrl = window.location.href.split('/').slice(0, -1).join('/');
        $
          .get(baseUrl + '/screeps/try-to-auth?token=' + token)
          .then(function (data) {
            console.log('try-to-auth returned', data);
            if (data.success) {
              window.location.reload();
            }
          });
      }
    }

    if (localstorageName) {
      tryToAuth();
    } else {
      afterGetSettings = tryToAuth;
    }
  });

  $(window).on('action:ajaxify.end', function (ev, data) {
    if (data.url === 'login' && !app.user.uid) {
      console.log('getting value of ', localstorageName);
      token = localStorage.getItem(localstorageName);
      console.log('got token ', token);
      // Unwrapping if it's in quotes
      token = (token[0]==='"' && token[token.length - 1]==='"') ?
        token.substr(1, token.length - 2) : token;
      console.log('unwrapped token ', token);
      var baseUrl = window.location.href.split('/').slice(0, -1).join('/');
      if (token) {
        window.location.href = baseUrl + '/screeps/login?token=' + token;
      } else {
        window.location.href = baseUrl + '/screeps/login';
      }
    }
  });

  console.log('nodebb-plugin-screeps: loaded');
  // Note how this is shown in the console on the first load of every page
}());
